import React from 'react'
import { Accordion } from 'react-bootstrap'
import "./accordionItem.scss"
import { ChevronUp } from 'react-feather';

interface AccordionItemProps {
  key: string;
  eventKey: string;
  accordionTitle?: string;
  accordionBody?: string
}

const AccordionItem: React.FC<AccordionItemProps> = ({ eventKey, accordionTitle, accordionBody, key }) => {
  return (
    <Accordion.Item key={key} eventKey={eventKey}>
      <Accordion.Header><h6 className='accordion-title mb-0'>{accordionTitle}</h6> <ChevronUp className='accordion-arrow' /></Accordion.Header>
      <Accordion.Body><p>{accordionBody}</p></Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionItem